import { create } from 'zustand';
import { fetchInterventieTasks } from '@/api/interventie';
import type { InterventieTask } from '@/api/interventie';

interface InterventieTasksState {
  tasks: InterventieTask[];
  loading: boolean;
  error: string | null;
  dayOffset: number; // -30 past to +5 ahead, 0 = today

  fetchTasks: () => Promise<void>;
  setDayOffset: (offset: number) => void;
}

export const useInterventieTasksStore = create<InterventieTasksState>((set) => ({
  tasks: [],
  loading: false,
  error: null,
  dayOffset: 0,

  fetchTasks: async () => {
    set({ loading: true, error: null });
    try {
      const tasks = await fetchInterventieTasks();
      set({ tasks, loading: false });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Interventies ophalen mislukt';
      set({ error: message, loading: false });
    }
  },

  setDayOffset: (offset) => set({ dayOffset: Math.max(-30, Math.min(5, offset)) }),
}));
